var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValidationCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-size",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7528_152778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91308 11.0352H7.91326C7.99256 11.0353 8.07081 11.0533 8.14213 11.088C8.21341 11.1226 8.27591 11.173 8.32497 11.2352L7.91308 11.0352ZM7.91308 11.0352H7.09394C6.89031 11.0352 6.7766 11.2698 6.90232 11.4292L6.90237 11.4293L10.1121 15.4957L10.1122 15.4957C10.3225 15.7619 10.7257 15.7611 10.9367 15.4962L10.9371 15.4957L16.6597 8.24398C16.6598 8.24378 16.66 8.24358 16.6602 8.24338C16.7884 8.08295 16.6699 7.85 16.4689 7.85H15.6498C15.4894 7.85 15.3367 7.9235 15.2376 8.05044C15.2375 8.05055 15.2374 8.05066 15.2373 8.05077L10.524 14.0216M7.91308 11.0352L10.524 14.0216M10.524 14.0216L8.32506 11.2353L10.524 14.0216Z",
    fill: "#323A46",
    stroke: "#0F9470",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 21.2858C17.1284 21.2858 21.2858 17.1284 21.2858 12.0001C21.2858 6.87171 17.1284 2.71436 12.0001 2.71436C6.87171 2.71436 2.71436 6.87171 2.71436 12.0001C2.71436 17.1284 6.87171 21.2858 12.0001 21.2858Z",
    stroke: "#0F9470",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7528_152778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationCheckCircle);
export default __webpack_public_path__ + "static/media/validation-check-circle.88e98972ea708b24c93e5293c91c631c.svg";
export { ForwardRef as ReactComponent };